import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WebinarLibraryService {
  AppUrl = '';
  constructor(private readonly _httpClient: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }

  i360WebinarLibraryAddUpdate(TokenKey: string, webinarLibraryModel: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/WebinarLibrary/i360WebinarLibraryAddUpdate';
    const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json', Token: TokenKey }) };
    return this._httpClient.post<any>(this.AppUrl + data, webinarLibraryModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  i360WebinarLibraryGet(TokenKey: string, filterModel: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/WebinarLibrary/i360WebinarLibraryGet';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._httpClient.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  i360WebinarLibraryFindbywebinarLibraryId(TokenKey: string, webinarLibraryId: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/WebinarLibrary/i360WebinarLibraryFindbywebinarLibraryId';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._httpClient.post<any>(this.AppUrl + data, webinarLibraryId, httpOptions)
      .pipe(catchError(this.handleError));
  }

  i360WebinarLibraryDelete(TokenKey: string, webinarLibraryId: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/WebinarLibrary/i360WebinarLibraryDelete';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._httpClient.post<any>(this.AppUrl + data, webinarLibraryId, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  i360WebinarSectionListWithIds(TokenKey: string): Observable<any> {
    this.setAPIUrl();
    const data = 'api/WebinarLibrary/i360WebinarSectionListWithIds';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._httpClient.get<any>(this.AppUrl + data, httpOptions).pipe(catchError(this.handleError));
  }

  i360WebinarUpdate(TokenKey: string, currentIndexid: string, previousIndexid: string): Observable<any[]> {
    this.setAPIUrl();

    const data = 'api/WebinarLibrary/i360WebinarDetailUpdate/' + currentIndexid + '/' + previousIndexid;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._httpClient.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }
}
